var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'product-size ' + _vm.extraClass},[_vm._v("\n    Available in size\n    "),_vm._l((_vm.sizes),function(size,i){return _c('span',{key:i,staticClass:"product-size__value"},[_vm._v("\n            "+_vm._s(size)+"\n    ")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2852529a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductSizes.vue
// module id = null
// module chunks = 